import { api } from '.';
import { TokenDetail, TokenRequest } from '../types';

export default async function getToken(request: TokenRequest) {
  return api<TokenDetail>('/api/v1/token', request);
}
